import React from "react";
import { Box, Grid, TextField } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const TextFieldSizes = () => {
  return (
    <>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={
            "6 color variations of textField. 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',"
          }
          language={"js"}
          value={
            '          <TextField placeholder={"Default (Primary)"} />\n' +
            '          <TextField color={"secondary"} placeholder={"Secondary"} />\n' +
            '          <TextField color={"error"} placeholder={"Error"} />\n' +
            '          <TextField color={"warning"} placeholder={"Warning"} />\n' +
            '          <TextField color={"info"} placeholder={"Info"} />\n' +
            '          <TextField color={"success"} placeholder={"Success"} />'
          }
        >
          <Grid container spacing={2} px={3}>
            <Grid item xs={4}>
              <TextField fullWidth placeholder={"Default (Primary)"} />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                color={"secondary"}
                placeholder={"Secondary"}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth color={"error"} placeholder={"Error"} />
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth color={"warning"} placeholder={"Warning"} />
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth color={"info"} placeholder={"Info"} />
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth color={"success"} placeholder={"Success"} />
            </Grid>
          </Grid>
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default TextFieldSizes;
